import type { MessageDescriptor } from '@lingui/core'
import { msg } from '@lingui/core/macro'

const METADATA_FIELD_LABEL_MESSAGES: Record<string, MessageDescriptor> = {
  Page: msg`Page`,
  Type: msg`Type`,
  'Drawing #': msg`Drawing #`,
  'Sheet #': msg`Sheet #`,
  'Revision Code': msg`Revision Code`,
  'Revision Date': msg`Revision Date`,
  System: msg`System`,
  Vendor: msg`Vendor`,
  'Viewing Rotation': msg`Viewing Rotation`,
  'Revision-controlled Drawing': msg`Revision-controlled Drawing`,
  'Design Facility': msg`Design Facility`,
  Title: msg`Title`,
  'Doc Type': msg`Doc Type`,
  Revision: msg`Revision`,
  'Rev. Date': msg`Rev. Date`,
  Pages: msg`Pages`,
}

/**
 * Display message for a metadata field label. The English label stays the
 * identity in draft maps and LABEL_TO_KEY lookups; only rendering translates.
 * Labels that come from data render unchanged.
 */
export const metadataFieldLabelMessage = (label: string): MessageDescriptor =>
  METADATA_FIELD_LABEL_MESSAGES[label] ?? { id: label, message: label }
